const TOKEN_ENDPOINT = '/api/form-token.php';
const SEND_ENDPOINT = '/api/send-email.php';

/**
 * Fetches a short-lived, signed, single-use token from the server.
 *
 * The form requests this on mount, well before the visitor can finish typing.
 * That is what lets the server tell a real form submission apart from a script
 * POSTing straight at the endpoint: no page load means no valid token. It also
 * timestamps the page load, so submissions that arrive within a few seconds
 * (faster than any human could type) are rejected.
 */
export const fetchFormToken = async () => {
  try {
    const response = await fetch(TOKEN_ENDPOINT, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    const result = await response.json();
    if (!response.ok || !result.success) {
      return null;
    }
    return { ts: result.ts, nonce: result.nonce, sig: result.sig };
  } catch (error) {
    console.error('Could not obtain form token:', error);
    return null;
  }
};

/**
 * Submits the contact form.
 *
 * `token`     - value from fetchFormToken()
 * `honeypot`  - the hidden field's value; humans leave it empty
 */
export const sendContactEmail = async (formData, token, honeypot = '') => {
  try {
    const response = await fetch(SEND_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...formData,
        website: honeypot,
        ts: token ? token.ts : '',
        nonce: token ? token.nonce : '',
        sig: token ? token.sig : '',
      }),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      return { success: false, error: result.error || 'Failed to send message.' };
    }

    return result;
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error: 'A network error occurred. Please try again.' };
  }
};
